export function getLoginErrText(code) {
  let msg = this.$t('login.fail')
  switch (code) {
    case 9002:
      msg = this.$t('error.userNotExist')
      break;
    case 8017:
      msg = this.$t('error.networkException')
      break;
    case 8018:
      msg = this.$t('error.phoneVerifyException')
      break;
    case 10:
      msg = this.$t('error.paramInvalid')
      break;
    case 50003:
      msg = this.$t('error.verifyCodeError')
      break;
    case 8009:
      msg = this.$t('error.accountRegisted')
      break;
    default:
    //
  }
  return msg
}


// WEBPACK FOOTER //
// ./static/js/functions.js